'use strict';

var message = {};

exports.__exports = message;
//# sourceMappingURL=message.cjs.map
